import React from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Paper,
  Divider,
  Link
} from "@mui/material";

function RecordDetails({ record }) {
  if (!record) {
    return (
      <Typography variant="body1" color="textSecondary">
        No record selected
      </Typography>
    );
  }

  // Parse the JSON field safely
  let parsedJson = {};
  try {
    parsedJson = record.json ? record.json : {};
  } catch (err) {
    console.error("Error parsing JSON field:", err);
  }

  const fields = [
    { label: "ID", value: record.id },
    { label: "File ID", value: record.fileid },
    { label: "Email", value: record.email },
    { label: "Name", value: record.name },
    { label: "Gladly URL", value: record.conversation_url ? (
        <Link
          href={record.conversation_url}
          target="_blank"
          rel="noopener noreferrer"
          underline="hover"
          color="primary"
        >
          {record.conversation_url}
        </Link>
      ) : (
        "—"
      ), },
    { label: "Status", value: record.status },
    { label: "Error Message", value: record.errorMessage },
    { label: "Retry Count", value: record.retryCount },
    { label: "Updated At", value: record.modified_at },
    { label: "Created At", value: record.created_at },
  ];

  return (
    <Box mt={2}>
      <Typography variant="h2" gutterBottom>
        Record Details
      </Typography>
      <Paper elevation={2}>
        <Table>
          <TableBody>
            {fields.map((field, index) => (
              <TableRow key={index}>
                <TableCell
                  component="th"
                  scope="row"
                  style={{ fontWeight: "bold", width: "200px" }}
                >
                  {field.label}
                </TableCell>
                <TableCell>{field.value || "—"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        {Object.keys(parsedJson).length > 0 && (
          <>
            <Divider />
            <Box p={2}>
              <Typography variant="h2" gutterBottom>
                File Data
              </Typography>
              <Table>
                <TableBody>
                  {Object.entries(parsedJson).map(([key, value]) => (
                    <TableRow key={key}>
                      <TableCell
                        component="th"
                        scope="row"
                        style={{ fontWeight: "bold", width: "200px" }}
                      >
                        {key}
                      </TableCell>
                      <TableCell>{String(value)}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </>
        )}
      </Paper>
    </Box>
  );
}

export default RecordDetails;
